import { motion } from "framer-motion";
import * as cx from "classnames/bind";
import {
  Modal,
  FileButton,
  Button,
  ButtonLink,
  Container,
  Section,
  ScrollX,
  Wistia,
  ArticleCard,
  CollectionCard,
} from "components";
import { HomeLayout } from "layouts";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import Head from "next/head";
import Image from "next/legacy/image";
import Link from "next/link";
import Script from "next/script";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useEffect, useState } from "react";
import { runQuery } from "queries";
import g from "styles/Gallery.module.scss";
import p from "styles/Partner.module.scss";

import { useGQLSWR, fetcher, imageUrl } from "utils";
import { request, gql } from "graphql-request";

const TFWA = ({
  articles,
  collections,
  setShowLoginModal,
  setLoginModalState,
  ...props
}) => {
  const { t } = useTranslation();
  const regex = /(<([^>]+)>)/gi;

  const results = null;
  const router = useRouter();

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(false);

  const [product, setProduct] = useState();
  const [cocktails, setCocktails] = useState([]);
  const [analyzing, setAnalyzing] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    const payload = JSON.stringify({ ...data, product });

    const message = {
      from_email: "no-reply@cocktailclub.com",
      subject: `CC Partner Inquiry - ${product}`,
      text: `
Name: ${data.name}
Mail: ${data.email}
Tlf: ${data.phone}
Message: ${data.message}
        `,
    };

    await fetch("/api/partner", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(message),
    });
    setShowModal(false);
    reset();
  };

  const openModal = (product) => {
    setProduct(product);
    setShowModal(true);
  };

  return (
    <>
      <div className={cx(p.partnerPage)}>
        <Section id="homeTop">
          <Container className="fullWidth">
            <div className={cx(p.homeBanner)}>
              <div className={cx("videoDisplayMob", p.videoDisplayMob)}>
                <Wistia code="3cskugg9re" size="177.71% 0 0 0" />
              </div>
              <div className={cx("videoDisplay", p.videoDisplay)}>
                <Wistia code="h6pw70dvz3" size="56.25% 0 0 0" />
              </div>
              <Container className={cx(p.homeContainer)}>
                <div className={cx("textDisplay text-center", p.textDisplay)}>
                  <h1 className="White">
                    {t("Welcome to")}
                    <br />
                    {t("TFWA Beach Party")}
                  </h1>
                  <div className="ButtonGroup hidden">
                    <ButtonLink
                      href="/cocktails"
                      size="fas"
                      svg="cocktail"
                      className="Primary Blue Rad50 Shadow"
                      title={t("Explore cocktails")}
                    >
                      {t("Explore cocktails")}
                    </ButtonLink>
                    <Button
                      size="fas"
                      svg="stars"
                      className="Primary Cyan Rad50 Shadow"
                      onClick={() =>
                        setLoginModalState({ show: true, index: 1 })
                      }
                      title={t("Join the club")}
                    >
                      {t("Join the club")}
                    </Button>
                  </div>
                </div>
                <div className={cx("appDisplay", p.appDisplay)}>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.app.cocktailclub20"
                    target="_blank"
                    rel="noreferrer"
                    id="btn-android"
                    title="Play store"
                  >
                    <Image
                      src="/img/playstore.png"
                      width={200}
                      height={59}
                      alt="Play store"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/no/app/cocktail-club-drink-recipes/id1599292471"
                    target="_blank"
                    rel="noreferrer"
                    id="btn-ios"
                    title="App store"
                  >
                    <Image
                      src="/img/appstore.png"
                      width={200}
                      height={59}
                      alt="App store"
                    />
                  </a>
                </div>
              </Container>
            </div>
            {/*
          <video
            autoPlay
            playsInline
            muted
            loop
            data-matomo-title="Frontpage intro video"
            title="Cocktail Club - Introduction"
            className="m__auto mb16 hidden"
          >
            <source
              src={`${process.env.NEXT_PUBLIC_S3_BUCKET}vid/pages/cocktailclub.mp4`}
              type="video/mp4"
            />
          </video>
          */}
          </Container>
        </Section>
        <Section>
          <Container>
            <div className={cx(p.something, "flex flex-wrap")}>
              <div className="split-item-50__d flex align-center">
                <h1 className={cx("Heading Bold")}>
                  {t(
                    "Boosting your bars profitability with our complete training programs is now easier than ever",
                  )}
                </h1>
              </div>
              <div className="split-item-50__d flex flex-wrap align-center">
                <p>
                  <b>{t("Meet Cocktail Club")}</b>
                  {t(
                    "- your ultimate bar training partner. We offer a comprehensive suite of digital services designed to boost profitability and efficiency for hotels, cruise lines, bars and restaurants.",
                  )}
                </p>
                <br />
                <Button
                  onClick={() => openModal("Inquery")}
                  className={cx("Primary Peach")}
                  style={{ color: "#000" }}
                >
                  {t("Find out more")}
                </Button>
              </div>
            </div>
          </Container>
        </Section>
        <Section>
          <Container>
            <div>
              <h2 className={cx(p.bigHeading, "Bold")}>
                {t("Transform your bar efficiency and experience")}
              </h2>
            </div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSection, p.paddingSectionBeige)}>
          <Container>
            <div className="flex flex-wrap row-reverse__d">
              <div className="split-item-50__d">
                <div className="imgRes">
                  <Image
                    src="/img/partner/IMG_header.png"
                    objectFit="cover"
                    layout="responsive"
                    height={900}
                    width={900}
                    alt="Get Started"
                    className="Rad"
                  />
                </div>
              </div>
              <div
                className="split-item-50__d flex align-center py36"
                style={{ background: "transparent" }}
              >
                <div className="contentInner">
                  <h4 className="Heading">{t("Turn seconds into savings")}</h4>
                  <p>
                    {t(
                      "Every second counts to enhance your staff skills and significantly boost your annual savings. Elevate efficiency and turn time into money-each saved second nets 0.2€.",
                    )}
                  </p>
                  <Button
                    onClick={() => openModal("Inquery")}
                    className={cx("Primary Peach")}
                    style={{ color: "#000" }}
                  >
                    {t("Discover more")}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSection, "b-white")}>
          <Container>
            <div className="flex flex-wrap">
              <div className="split-item-50__d">
                <div className={cx(p.imageMarginRight, "imgRes")}>
                  <Image
                    src="/img/partner/v169_1978.png"
                    objectFit="cover"
                    layout="responsive"
                    height={900}
                    width={900}
                    alt="Get Started"
                    className={cx("Rad")}
                  />
                </div>
              </div>
              <div
                className="split-item-50__d flex align-center py36"
                style={{ background: "transparent" }}
              >
                <div className="contentInner">
                  <h4 className="Heading">
                    {t("Industry experts at your service")}
                  </h4>
                  <p>
                    {t(
                      "Gain exclusive access to training by the industry elite and a cocktail menu meticulously designed by expert bartenders worldwide.",
                    )}
                  </p>
                  <Button
                    onClick={() => openModal("Inquery")}
                    className={cx("Primary Peach")}
                    style={{ color: "#000" }}
                  >
                    {t("Request info")}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSection, p.paddingSectionBeige)}>
          <Container>
            <div className="flex flex-wrap row-reverse__d">
              <div className="split-item-50__d">
                <div className="imgRes">
                  <Image
                    src="/img/partner/v168_1926.png"
                    objectFit="cover"
                    layout="responsive"
                    height={900}
                    width={900}
                    alt="Get Started"
                    className="Rad"
                  />
                </div>
              </div>
              <div
                className="split-item-50__d flex align-center py36"
                style={{ background: "transparent" }}
              >
                <div className="contentInner">
                  <h4 className="Heading">
                    {t("Consistent quality: signature cocktail experience")}
                  </h4>
                  <p>
                    {t(
                      "Ensure every drink meets the mark of excellence, offering a consistent, quality cocktail experience to every customer, every time.",
                    )}
                  </p>
                  <Button
                    onClick={() => openModal("Inquery")}
                    className={cx("Primary Peach")}
                    style={{ color: "#000" }}
                  >
                    {t("Discover more")}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSectionBig, "b-white")}>
          <Container>
            <div className="text-center">
              <h2 className={cx(p.secondBigHeading, "Heading")}>
                Every sip supports sustainability - Guiding your culture and
                decisions for greener practices
              </h2>
              <Button
                onClick={() => openModal("Inquery")}
                className={cx("Primary Peach")}
                style={{ color: "#000" }}
              >
                {t("Discover more")}
              </Button>
            </div>
          </Container>
        </Section>
        <Section
          className={cx(
            p.paddingSection,
            p.paddingSectionBeige,
            p.exploreSection,
          )}
        >
          <Container>
            <div className={cx(p.exploreHeader)}>
              <h2 className="Heading mb8">
                {t("Empower your team with knowledge and support")}
              </h2>
            </div>
            <motion.div initial="hidden" animate="show">
              <ScrollX
                className={cx("GalleryFeed i-4", g.GalleryFeed, g.CourseFeed)}
              >
                <div className={cx("rowItem rowItemScroll__L", g.CourseItem)}>
                  <div>
                    <div
                      className={cx(
                        "GalleryImageWrapper Rad ofh p32",
                        g.CourseImageWrapper,
                      )}
                    >
                      <Image
                        src="/img/partner/glas.svg"
                        layout="intrinsic"
                        height={100}
                        width={100}
                        alt="Recipe Mastery"
                        objectFit="contain"
                      />
                    </div>
                    <div
                      className={cx(g.CourseInfo)}
                      style={{ justifyContent: "normal" }}
                    >
                      <h3 className="Heading__sub Bold mb8">
                        {t("Recipe mastery")}
                      </h3>
                      <p>
                        {t(
                          "Keep your team ahead with the latest in-house recipes, ensuring they are always prepared to impress.",
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={cx("rowItem rowItemScroll__L", g.CourseItem)}>
                  <div>
                    <div
                      className={cx(
                        "GalleryImageWrapper Rad ofh p32",
                        g.CourseImageWrapper,
                      )}
                    >
                      <Image
                        src="/img/partner/database.svg"
                        layout="intrinsic"
                        height={100}
                        width={100}
                        alt="Global drinks database"
                        objectFit="contain"
                      />
                    </div>
                    <div
                      className={cx(g.CourseInfo)}
                      style={{ justifyContent: "normal" }}
                    >
                      <h3 className="Heading__sub Bold mb8">
                        {t("Global drinks database")}
                      </h3>
                      <p>
                        {t(
                          "Provide instant access to a comprehensive enclopedia of world-standard drinks (IBA), ready to meet any customer request with confidence.",
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={cx("rowItem rowItemScroll__L", g.CourseItem)}>
                  <div>
                    <div
                      className={cx(
                        "GalleryImageWrapper Rad ofh p32",
                        g.CourseImageWrapper,
                      )}
                    >
                      <Image
                        src="/img/partner/chart.svg"
                        layout="intrinsic"
                        height={100}
                        width={100}
                        alt="Dashboard insights"
                        objectFit="contain"
                      />
                    </div>
                    <div
                      className={cx(g.CourseInfo)}
                      style={{ justifyContent: "normal" }}
                    >
                      <h3 className="Heading__sub Bold mb8">
                        {t("Dashboard insights")}
                      </h3>
                      <p>
                        {t(
                          "Unlock a clear view of how your staff interacts with our app, enabling prices management and training adjustments.",
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={cx("rowItem rowItemScroll__L", g.CourseItem)}>
                  <div>
                    <div
                      className={cx(
                        "GalleryImageWrapper Rad ofh p32",
                        g.CourseImageWrapper,
                      )}
                    >
                      <Image
                        src="/img/partner/brain.svg"
                        layout="intrinsic"
                        height={100}
                        width={100}
                        alt="Ai support"
                        objectFit="contain"
                      />
                    </div>
                    <div
                      className={cx(g.CourseInfo)}
                      style={{ justifyContent: "normal" }}
                    >
                      <h3 className="Heading__sub Bold mb8">
                        {t("AI support")}
                      </h3>
                      <p>
                        {t(
                          "Empower your staff with 24/7 AI-driven support within the app, ensuring they have the answers they need, anytime.",
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollX>
            </motion.div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSection, "b-white")}>
          <Container>
            <div className="flex flex-wrap row-reverse__d">
              <div className="split-item-50__d">
                <div className={cx(p.imageMarginLeft, "imgRes")}>
                  <Image
                    src="/img/get_started.jpg"
                    objectFit="cover"
                    layout="responsive"
                    height={900}
                    width={900}
                    alt="Get Started"
                    className="Rad"
                  />
                </div>
              </div>
              <div
                className="split-item-50__d flex align-center py36"
                style={{ background: "transparent" }}
              >
                <div className="contentInner">
                  <h4 className="Heading">
                    {t("Engage your customers with interactive menus")}
                  </h4>
                  <p>
                    {t(
                      "Enhance your menu with direct links to our software, inviting guests to explore your cocktail offerings in a whole new way.",
                    )}
                  </p>
                  <Button
                    onClick={() => openModal("Inquery")}
                    className={cx("Primary Peach")}
                    style={{ color: "#000" }}
                  >
                    {t("Request info")}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSection, p.paddingSectionBeige)}>
          <Container>
            <div className="flex flex-wrap">
              <div className="split-item-50__d">
                <div className={cx(p.imageMarginRight, "imgRes")}>
                  <Image
                    src="/img/get_started.jpg"
                    objectFit="cover"
                    layout="responsive"
                    height={900}
                    width={900}
                    alt="Get Started"
                    className={cx("Rad")}
                  />
                </div>
              </div>
              <div
                className="split-item-50__d flex align-center py36"
                style={{ background: "transparent" }}
              >
                <div className="contentInner">
                  <h4 className="Heading">{t("QR-code convenience")}</h4>
                  <p>
                    {t(
                      "Streamline your service with automated QR codes and links, making it easy for guests and staff to take their favourite Cocktail recipes home.",
                    )}
                  </p>
                  <Button
                    onClick={() => openModal("Inquery")}
                    className={cx("Primary Peach")}
                    style={{ color: "#000" }}
                  >
                    {t("Discover more")}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </Section>
        <Section className={cx(p.paddingSectionBig, "b-white")}>
          <Container>
            <div className="text-center">
              <h2 className={cx(p.secondBigHeading, "Heading")}>
                {t("Start living a unique and profitable experience")}
              </h2>
              <ButtonLink
                href="/download"
                className="Primary Peach"
                style={{ color: "#000" }}
              >
                {t("Download the app")}
              </ButtonLink>
            </div>
          </Container>
        </Section>
        <Modal
          onClose={() => setShowModal(false)}
          show={showModal}
          title={t("Request more information")}
        >
          <p>
            {t(
              "We will contact you within 1-3 business days after you have sent us your inquiry",
            )}
          </p>
          <form className="input" onSubmit={handleSubmit(onSubmit)}>
            <div className="inputContainer noLabel">
              <input
                className={cx({ error: errors.name })}
                {...register("name", { required: true })}
                id="name"
                placeholder={t("Full name")}
              />
              <label htmlFor="name">{t("Full name")}</label>
            </div>
            <div className="inputContainer noLabel">
              <input
                className={cx({ error: errors.email })}
                {...register("email", {
                  required: true,
                  pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                })}
                id="email"
                type="email"
                placeholder={t("Email")}
              />
              <label htmlFor="email">{t("Email")}</label>
            </div>
            <div className="inputContainer noLabel">
              <input
                className={cx({ error: errors.phone })}
                {...register("phone", {
                  required: true,
                  pattern: /^\+?[0-9\ ]*$/gim,
                })}
                id="phone"
                type="tel"
                placeholder={t("Phone number")}
              />
              <label htmlFor="phone">{t("Phone number")}</label>
            </div>
            <div className="inputContainer noLabel">
              <textarea
                {...register("message")}
                id="message"
                placeholder={t("Message")}
              />
              <label htmlFor="message">{t("Inquiry")}</label>
            </div>
            <div className="inputContainer">
              <input
                type="submit"
                className="Button Primary Full Cyan"
                value={t("Send inquiry")}
              />
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
};

TFWA.getLayout = (page) => {
  return (
    <>
      <HomeLayout style={{ paddingTop: "0px" }}>
        <Head>
          <title key="title">TFWA Beach Party - Cocktail Club</title>
          <meta
            key="description"
            name="description"
            content="Boosting your bars profitability with our complete training programs is now easier than ever"
          />
          <meta
            key="ogUrl"
            property="og:url"
            content="https://cocktailclub.com/tfwa-beach-party"
          />
          <link
            key="canonical"
            rel="canonical"
            href="https://cocktailclub.com/tfwa-beach-party"
          />

          <meta key="ogType" property="og:type" content="website" />
          <meta
            key="ogTitle"
            property="og:title"
            content="TFWA Beach Party - Cocktail Club"
          />
          <meta
            key="ogDescription"
            property="og:description"
            content="Boosting your bars profitability with our complete training programs is now easier than ever"
          />
        </Head>
        {page}
      </HomeLayout>
      ;
    </>
  );
};

export const getStaticProps = async ({ locale }) => {
  const ids = [1, 2, 3];
  const query = gql`
    query {
      articles(where: { hidden: { _eq: false } }, order_by: { id: desc }) {
        id
        title
        slug
        translations
        excerpt
        image_id
        hidden
        featured
        categories {
          category {
            name
            slug
            translations
          }
        }
      }
      categories: article_categories(
        where: {
          _not: { articles_aggregate: { count: { predicate: { _eq: 0 } } } }
        }
      ) {
        id
        name
        slug
      }
      collections: categories(
        where: { hidden: { _eq: false } }
        order_by: { id: desc }
      ) {
        id
        name
        translations
        slug
        hidden
        featured
        image_id
        cocktail_categories_aggregate(
          where: { cocktail: { _not: { hidden: { _eq: true } } } }
        ) {
          aggregate {
            count
          }
        }
      }
    }
  `;
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      ...(await fetcher(query)),
      ...(
        await runQuery("cocktails/multiple", {
          filter: `{id: {_in: [${ids.join(",")}]}}`,
        })
      ).props,
    },
    revalidate: 60,
  };
};

export default TFWA;
